var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.$store.state.isNavBarOff)?_c('HeaderNav',{attrs:{"auth":_vm.$store.state.isAuth}}):_vm._e(),(_vm.$store.state.isNavBarOff)?_c('SideBarDesktop'):_vm._e(),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper-lc"},[_c('div',{staticClass:"container"})])
}]

export { render, staticRenderFns }